export const BLOCK_FSE = 'BLOCK_FSE'
export const BLOCK_FSE_ERR = 'BLOCK_FSE_ERR'

export const GET_FSE_LEAD = 'GET_FSE_LEAD'
export const GET_FSE_LEAD_ERR = 'GET_FSE_LEAD_ERR'
